// extracted by mini-css-extract-plugin
export var logo = "_ir-2";
export var logoWrapper = "_ir-1";
export var strip = "_ir-0";